import api from '@/api/axios'

export const getCategory = async () => {
  const response = await api.get(`/categories/all`)
  return response.data
}

export const getSubCategoryByCategory = async (parentId) => {
  const response = await api.get(`/categories/all?parentId=${parentId}`)
  return response.data
}

export const getCategoryDetailsById = async (id) => {
  const response = await api.get(`/categories/${id}`)
  return response.data
}

export const getCategoryDetailsBySlug = async (slug) => {
  const response = await api.get(`/categories/details/${slug}`)
  return response.data
}